import { describeActionError } from "@/lib/staff-errors";

interface ActionErrorProps {
  error: unknown;
  subject?: "employee" | "order";
  onReload: () => void;
}

/** A refused action, inline where it happened, in plain words. A stale row
 *  gets a Reload button rather than a retry on the same etag. */
export function ActionError({ error, subject = "employee", onReload }: ActionErrorProps): React.ReactElement | null {
  if (!error) return null;
  const { message, reload } = describeActionError(error, subject);
  return (
    <div
      role="alert"
      className="mt-2 flex flex-wrap items-center gap-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800"
    >
      <span>{message}</span>
      {reload && (
        <button type="button" onClick={onReload} className="font-semibold underline hover:text-red-900">
          Reload
        </button>
      )}
    </div>
  );
}
